import { fExecuteAPI } from "../../Server/Apis";
import {
  INVBTOUT_updateBatchDispatch_GETROW,
  INVBTOUT_getDispatchDetailsForGrid_GETROW,
  INVBTOUT_batchDispatchDetailApprove_GETROW,
  INVBTOUT_getInv04VersionDetails_GETROW,
  INVBTOUT_getBatchDispatchDetails_GETROW,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";

import moment from "moment";
import { vRdxUserInfo, BatchOutRo } from "../../Redux/roStore";
import { Set_HeadObj_DetailHead_Update } from "./SliceBatchOut";
// item
export const GCToggleSearch_ItemName_Columns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];
export const GCToggleSearch_ItemName_Select_Arr = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

//customer
export const xGC_Toggle_Head_BinName_GridColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "BinAttr1", headerName: "BinAttr1", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const xGC_Toggle_Head_BinName_DropDown_Arr = ["Any", "Code", "Name"];

export const ErrorMsgDetail = {
  DP_SrNo: "",
  DP_Batch: "",
  DP_ItmCd: "",
  ItmName: "",
  DP_Qty: "", // Assuming quantity is numeric
  DP_Unit: "",
  UnitName: "",
  DP_BaseQty: "", // Assuming base quantity is numeric
  B_PackQty: "",
  B_Packing: "",
  BacthQty: "",
  ResQty: "",
  BalQty: "",
  TransQty: "",
  AllocQty: "",
  BalalanceQty: "",
};

export const sTrnTyp = "IPT01";

const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI("SEARCHEXACTITEM_GETROW", FinalObj);
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull?.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const fItemCodeDependency = async (
  vItemSearchFull,
  setBufferObj,
  setUnit,
  defUnitValue = ""
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      DP_ItmCd: vItemSearchFull[0].ItmCd,
      ItmName: vItemSearchFull[0].Name2,
    }));
    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === vItemSearchFull[0].DefUnit;
      });
      if (!!vItemUnitSet) {
        setBufferObj((obj) => ({
          ...obj,
          DP_Unit: vItemUnitSet.Unit,
          UnitName: vItemUnitSet.Name1,
          B_PackQty: vItemUnitSet.PackQty,
        }));
      } else {
        setBufferObj((obj) => ({
          ...obj,
          DP_Unit: currentUnitArr[0].Unit,
          UnitName: currentUnitArr[0].Name1,
          B_PackQty: vItemUnitSet.PackQty,
        }));
      }
       
    }
    setTimeout(() => {
      const element = document.querySelector('[tabindex="103"]');
      element.focus();
    }, 500);
    // document.getElementsByName("GC_Toggle_Head_BinName_Name")[0].focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
const fValidationHead_Client = (vRdxHead) => {
  let iRes = true;
  // let xObjHasNullOrUndefinevale =
  //   fCheck_Value_Null_Or_Undefined_ShowAlert(vRdxHead);
  // fAlertToast("WARNING", xObjHasNullOrUndefinevale); 
  const { DetailHead } = BatchOutRo();
  if (
    DetailHead.Version === "" ||
    DetailHead.Version === null ||
    DetailHead.Version === undefined
  ) {
    fAlertToast("FAILED", "Version  should be  Enter");
    iRes = false;
  }

  // default format so no need to check format
  if (
    DetailHead.DispatchDate1 === "" ||
    DetailHead.DispatchDate1 === null ||
    DetailHead.DispatchDate1 === undefined
  ) {
    fAlertToast("FAILED", "Dispatch Date  should be  Enter");
    iRes = false;
  }

  if (vRdxHead.Status !== "ENTER") {
    fAlertToast("FAILED", "Document status should be  Enter");
    iRes = false;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;
  if (sBufferObj.DP_SrNo === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      DP_SrNo: "Serial number should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.DP_Batch === "" ||
    sBufferObj.DP_Batch === null ||
    sBufferObj.DP_Batch === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      DP_Batch: "Batch should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.DP_ItmCd === "" ||
    sBufferObj.DP_ItmCd === null ||
    sBufferObj.DP_ItmCd === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      DP_ItmCd: "Item code should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      ItmName: "Item name should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.DP_Qty === "" ||
    Number(sBufferObj.DP_Qty) <= 0 ||
    (sBufferObj.DP_Qty === null) | (sBufferObj.DP_Qty === undefined)
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      DP_Qty: "Qty should not be zero",
    }));
    iRes = false;
  }

  if (sBufferObj.DP_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, DP_Unit: "Select unit" }));
    iRes = false;
  }

  return iRes;
};
//API SaveSIHead
const   fSaveHead = async (fNewDetail, sBufferObj, dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObj } = BatchOutRo();
  const { DetailHead } = BatchOutRo();
  let vSaveSIHeadObj = {
    v_TrnTyp: HeadObj.TrnTyp,
    v_VS_VocTyp: HeadObj.A_VocTyp,
    v_VS_VocNo: HeadObj.A_VocNo,
    v_VS_Loc: HeadObj.A_Loc,
    v_VS_Version: DetailHead.Version,
    v_VS_PostDt: moment(HeadObj.A_PostDt).format("MM/DD/YYYY"),
    v_VS_DoDt: moment(DetailHead.DispatchDate1).format("MM/DD/YYYY"),
    v_VS_Status: HeadObj.Status,
    v_VS_UserCd: vRdxUserInfoObj.UserID,
    B_ItmCd: sBufferObj.DP_ItmCd,
    v_UserId: vRdxUserInfoObj.UserID,
    v_Qty: sBufferObj.DP_Qty,
    v_Unit: sBufferObj.DP_Unit,
    v_BatchNo: sBufferObj.DP_Batch,
    v_SrNo: sBufferObj.DP_SrNo, 
    DP_v_DP_BaseQty: sBufferObj.DP_BaseQty,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = await INVBTOUT_updateBatchDispatch_GETROW(FinalObj);
  if (vSaveSIHead?.status === 200) {
    //approve bool type false

    let { DetailHead } = BatchOutRo();
    dispatch(
      Set_HeadObj_DetailHead_Update({
        ...DetailHead,
        Version: vSaveSIHead?.data?.ResultSet?.updatedVersion,
      })
    );
    // iSIDetailResult?.data.ResultSet;
    fAlertToast("SUCCESS", "Saved successfully");
    fNewDetail();
  }
};
const fSaveApprove = async (fNewDetail,navigate) => {
  const { HeadObj } = BatchOutRo();
  const { DetailHead } = BatchOutRo();
  let vSaveSIHeadObj = {
    v_TrnTyp: HeadObj.TrnTyp,
    v_Loc: HeadObj.A_Loc,
    v_DP_VocTyp: HeadObj.A_VocTyp,
    v_DP_VocNo: HeadObj.A_VocNo,
    v_DP_Version: DetailHead.Version,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = await INVBTOUT_batchDispatchDetailApprove_GETROW(
    FinalObj
  );
  if (vSaveSIHead?.status === 200) {
    fAlertToast("SUCCESS", "Approved successfully");
    fNewDetail();
    navigate("/BatchOut");

  }
};

const GetSIDetail = async () => {
  const { HeadObj } = BatchOutRo();
  const { DetailHead } = BatchOutRo();
  let iSIDetailObj = {
    v_VocTyp: HeadObj.A_VocTyp,
    v_VocNo: HeadObj.A_VocNo,
    v_TrnTyp: HeadObj.TrnTyp,
    v_Version: DetailHead.Version,
    v_Loc: HeadObj.A_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await INVBTOUT_getDispatchDetailsForGrid_GETROW(
    FinalObj
  );
  if (iSIDetailResult.status === 200) {
    if (iSIDetailResult?.data?.ResultSet?.length > 0) {
      return iSIDetailResult?.data.ResultSet;
    } else {
      return [];
    }
  }
};
const GetBatchDispatch = async (xBatxh,sBufferObj) => {
  const { HeadObj } = BatchOutRo();
  const { DetailHead } = BatchOutRo();
  let iSIDetailObj = { 
    v_VocTyp: HeadObj.A_VocTyp,
    v_VocNo: HeadObj.A_VocNo,
    v_SrNo:sBufferObj.DP_SrNo, 
    v_BatchNo:xBatxh, 
    v_TrnTyp: HeadObj.TrnTyp,
    v_Version: DetailHead.Version,
    v_Loc: HeadObj.A_Loc,  
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);
 
  const iSIDetailResult = await INVBTOUT_getBatchDispatchDetails_GETROW(
    FinalObj
  );
  if (iSIDetailResult.status === 200) {
    if (iSIDetailResult?.data?.ResultSet) {
      return iSIDetailResult?.data.ResultSet;
    } else {
      return [];
    }
  }
};
const GetSIDetailVersion = async (set) => {
  const { HeadObj } = BatchOutRo();
  let iSIDetailObj = {
    VocTyp: HeadObj.A_VocTyp,
    VocNo: HeadObj.A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await INVBTOUT_getInv04VersionDetails_GETROW(
    FinalObj
  );
  if (iSIDetailResult.status === 200) {
    if (iSIDetailResult?.data?.ResultSet?.length > 0) {
      set(iSIDetailResult.data.ResultSet);
      return iSIDetailResult?.data.ResultSet;
    } else {
    
      set([]);
      return [];
    }
  }
};
const fLoad_Grid = async (setDetailGridData) => {
  const iSIDetail = await GetSIDetail();
  if (iSIDetail?.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};
export {
  GetItemFullSearchArr,
  GetUnitArr,
  fItemCodeDependency,
  GetSearchItem,
  fValidationDetail_Client,
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
  fSaveApprove,
  GetSIDetailVersion,
  GetBatchDispatch
};
